module.exports = __webpack_public_path__ + "media/images/job-promotion-c364e8093ac986a1b0665f40c99c45f9.svg";